export default {
  'locations.field.name': 'Name',
  'locations.field.code': 'Code',
  'locations.field.country': 'Country',
  'locations.field.city': 'City',
  'locations.field.state': 'State',
  'locations.field.zip': 'Zip',
  'locations.field.timezone': 'Timezone',
  'locations.field.types': 'Types',
  'locations.field.types.sea_port': 'Sea Port',
  'locations.field.types.airport': 'Airport',
  'locations.field.types.rail_terminal': 'Rail Terminal',
  'locations.field.types.postal_exchange': 'Postal Exchange',
  'locations.field.types.road_terminal': 'Road Terminal',
  'locations.port.create.title': 'Create new port',
  'locations.port.edit.title': 'Edit port',
  'locations.port.delete.title': 'Delete port',
  'locations.port.delete.confirm.title': 'Delete port',
  'locations.port.delete.confirm.content': 'Are you sure you want to delete this port?',
  'locations.port.delete.confirm.button': 'Delete',
  'locations.port.delete.success': 'Port deleted successfully',
  'locations.port.update.success': 'Port updated successfully',
  'locations.port.create.success': 'Port created successfully',
  'locations.port.list_title.all': 'All Ports',
};
